import { useDispatch } from "react-redux";

import {
  closeSection,
  expandSection,
  sendAddToCalendarGA
} from "../../slices/uiSlice";

export const useUIBehavior = () => {
  const dispatch = useDispatch();

  return {
    expandSection: () => dispatch(expandSection()),
    closeSection: () => dispatch(closeSection()),
    sendAddToCalendarGA: openHouseId =>
      dispatch(sendAddToCalendarGA(openHouseId))
  };
};
